import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

export default (ctx, inject) => {
	const echo = new Echo({
		broadcaster: 'pusher',
		key: process.env.PUSHER_APP_KEY,
		wsHost: process.env.PUSHER_APP_HOST,
		wsPort: process.env.PUSHER_APP_PORT,
		wssPort: process.env.PUSHER_APP_PORT,
		forceTLS: process.env.PUSHER_APP_SCHEME === 'https',
		encrypted: true,
		disableStats: true,
		enabledTransports: ['ws', 'wss'],
		authorizer: (channel, options) => {
			return {
				authorize: (socketId, callback) => {
					ctx.$axios
						.post(process.env.PUSHER_APP_AUTH_ENDPOINT, {
							socket_id: socketId,
							channel_name: channel.name,
							participant_uuid: ctx.$auth.user?.uuid,
						})
						.then((response) => {
							callback(false, response.data);
						})
						.catch((error) => {
							callback(true, error);
						});
				},
			};
		},
	});

	inject('echo', echo);
};
